import { Mutation } from '@tilework/opus';

export class JewelryInquiryFormQuery {
    getSendJewelryInquiryMutation(options) {
        const mutation = new Mutation('JewelryInqury');

        this._addSendJewelryInquiryMutationArguments(mutation, options);
        mutation.addFieldList(this._getSendJewelryInquiryMutationResponse());

        return mutation;
    }

    _addSendJewelryInquiryMutationArguments(
        mutation,
        options,
    ) {
        return mutation.addArgument('input', 'InquryForm', options);
    }

    _getSendJewelryInquiryMutationResponse() {
        return ['message'];
    }
}

export default new JewelryInquiryFormQuery();